import * as User from './UserTyping';

// user 统一上报
class UserReporter {
  private userIns: any;
  constructor() {
    this.userIns = null;
  }
  public init(user: any) {
    this.userIns = user;
    this.bindListener();
  }
  private bindListener() {
    this.userIns.on('login-type-changed', (val: string) => {
      if (val === User.LoginTypeKey.loginWithWechat) {
        reporter.report('login_wechat', {
          login_wechat_detail: 'show',
        });
      } else if (val === User.LoginTypeKey.loginWithAppCode) {
        reporter.report('login_scan', {
          login_scan_detail: 'show',
        });
      } else if (val === User.LoginTypeKey.loginWithPhone) {
        reporter.report('login_phone', {
          login_phone_detail: 'show',
        });
      }
    });
    this.userIns.on('verified', ({ org_id, channel_source }: { org_id: number; channel_source: string }) => {
      if (org_id === -1) return;
      reporter.report('tced_new', {
        org_id: `${org_id}`,
        channel_source,
      });
    });
    this.userIns.on('logined', async () => {
      const loginTypeParam = this.userIns.getUserInfo().loginType;
      await this.userIns.store.dispatch('getUserBaseInfo');
      const { isTemporary } = this.userIns.store.getters.userBaseInfo;
      reporter.report('login', {
        loginType: loginTypeParam,
        user_type: isTemporary ? 'temporary_member' : 'user',
      });
      if (loginTypeParam === User.LoginTypeKey.loginWithAppCode) {
        reporter.report('login_scan', {
          login_scan_detail: 'success',
        });
      } else if (loginTypeParam === User.LoginTypeKey.loginWithPhone) {
        reporter.report('login_phone', {
          login_phone_detail: 'success',
        });
      } else if (loginTypeParam === User.LoginTypeKey.loginWithWechat) {
        reporter.report('login_wechat', {
          login_wechat_detail: 'success',
        });
      }
      // 登录完成且上报完成后清除信息
      this.userIns.resetLoginInfo();
    });
  }
}
const userReporter = new UserReporter();
export default userReporter;
